import React from "react";
import { useLocation } from "react-router-dom";

import analytics from "../services/analytics";

export default function usePageTracking() {
  const location = useLocation();

  React.useEffect(() => {
    analytics.init();
  }, []);

  // Fires each time the page location changes
  React.useEffect(() => {
    // Ask Google Analytics to track the page
    const currentPath = location.pathname + location.search;
    analytics.sendPageview(currentPath);

    // Ask Mixpanel to track the page
    if (window.mixpanel) {
      window.mixpanel.track_pageview();
    }
  }, [location]);
}
